import { updateEventCache } from 'graphql/cache/events';
import { updateEventSectionCache } from 'graphql/cache/sections';

import { EVENT_SECTION } from 'graphql/fragments/sections';
import {
  ADD_SONG_IDEAS_TO_EVENT_SECTION,
  DELETE_SONG_IDEAS_FROM_EVENT_SECTION,
  REORDER_EVENT_SECTION_SONG_IDEAS,
  UPDATE_EVENT,
  UPDATE_EVENT_SECTION,
  UPDATE_SECTION_BLOCKS,
} from 'graphql/mutations/events';
import {
  ANSWER_EVENT_SECTION_QUESTION_V2,
  CLONE_EVENT_SECTION_QUESTION,
  CREATE_EVENT_SECTION_QUESTION_V2,
  DELETE_EVENT_SECTION_QUESTION,
  MOVE_QUESTIONS_BETWEEN_EVENT_SECTIONS,
  REORDER_EVENT_SECTION_QUESTION,
  UPDATE_EVENT_SECTION_QUESTION_V2,
} from 'graphql/mutations/questions';
import { MOVE_SECTION_SONGS, REORDER_SONGS_BATCH } from 'graphql/mutations/songs';
import {
  GET_EVENT_SECTION_COMPANY_SONG_IDEAS,
  GET_EVENT_SECTION_SONG_IDEAS,
  GET_EVENT_SECTION_USER_SONG_IDEAS,
  GET_EVENT_SECTION_VIBO_SONG_IDEAS,
} from 'graphql/queries/events';
import { GET_EVENT_SECTION_QUESTIONS_V2 } from 'graphql/queries/questions';
import { GET_EVENT_SECTION_SONG_IDEAS_SONGS } from 'graphql/queries/songIdeas';

import { EventTimelineGqlOptions } from './interfaces';

const DEFAULT_QUESTIONS_REFETCH_Q = ['sections', 'getEventSectionQuestionsV2'];

export const EVENT_TIMELINE_GQL: EventTimelineGqlOptions = {
  event: {
    mutations: {
      update: {
        mutation: UPDATE_EVENT,
        updateCache: updateEventCache,
      },
    },
  },
  sections: {
    mutations: {
      moveSongs: {
        mutation: MOVE_SECTION_SONGS,
        refetchQ: ['sections', 'getSectionSongs', 'getSectionSongsStats'],
      },
      moveQuestions: {
        mutation: MOVE_QUESTIONS_BETWEEN_EVENT_SECTIONS,
        refetchQ: ['sections', 'getEventSectionQuestionsV2'],
      },
      updateSection: {
        mutation: UPDATE_EVENT_SECTION,
        refetchQ: ['sections'],
        updateCache: updateEventSectionCache,
      },
    },
    fragments: {
      section: EVENT_SECTION,
    },
  },
  songs: {
    mutations: {
      reorder: {
        mutation: REORDER_SONGS_BATCH,
        refetchQ: ['getSectionSongs'],
      },
    },
  },
  playlists: {
    queries: {
      user: {
        key: 'getEventSectionUserSongIdeas',
        query: GET_EVENT_SECTION_USER_SONG_IDEAS,
      },
      vibo: {
        key: 'getEventSectionViboSongIdeas',
        query: GET_EVENT_SECTION_VIBO_SONG_IDEAS,
      },
      company: {
        key: 'getEventSectionCompanySongIdeas',
        query: GET_EVENT_SECTION_COMPANY_SONG_IDEAS,
      },
      section: {
        key: 'getEventSectionSongIdeas',
        query: GET_EVENT_SECTION_SONG_IDEAS,
      },
      songs: {
        key: 'getEventSectionSongIdeasSongs',
        query: GET_EVENT_SECTION_SONG_IDEAS_SONGS,
      },
    },
    mutations: {
      add: {
        mutation: ADD_SONG_IDEAS_TO_EVENT_SECTION,
      },
      delete: {
        mutation: DELETE_SONG_IDEAS_FROM_EVENT_SECTION,
      },
      reorder: {
        mutation: REORDER_EVENT_SECTION_SONG_IDEAS,
      },
    },
  },
  questions: {
    queries: {
      questions: {
        query: GET_EVENT_SECTION_QUESTIONS_V2,
        key: 'getEventSectionQuestionsV2',
      },
    },
    mutations: {
      create: {
        mutation: CREATE_EVENT_SECTION_QUESTION_V2,
        refetchQ: DEFAULT_QUESTIONS_REFETCH_Q,
      },
      clone: {
        mutation: CLONE_EVENT_SECTION_QUESTION,
        refetchQ: DEFAULT_QUESTIONS_REFETCH_Q,
      },
      update: {
        mutation: UPDATE_EVENT_SECTION_QUESTION_V2,
        refetchQ: DEFAULT_QUESTIONS_REFETCH_Q,
      },
      answer: {
        mutation: ANSWER_EVENT_SECTION_QUESTION_V2,
      },
      reorder: {
        mutation: REORDER_EVENT_SECTION_QUESTION,
        refetchQ: ['getEventSectionQuestionsV2'],
      },
      delete: {
        mutation: DELETE_EVENT_SECTION_QUESTION,
        refetchQ: DEFAULT_QUESTIONS_REFETCH_Q,
      },
      updateBlocks: {
        mutation: UPDATE_SECTION_BLOCKS,
        refetchQ: DEFAULT_QUESTIONS_REFETCH_Q,
      },
    },
  },
};
